export default __webpack_public_path__ + "images/864482f64d7425d9fef858dba4803673-fighterPlane.png";